import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: 'auto !important',
  [theme.breakpoints.up('lg')]: {
    margin: theme.spacing(1),
    border: `1px solid ${theme.palette.overlay[1]}`,
    borderRadius: theme.spacing(0.5),
  },
  '& .DPHDateItem': {
    textAlign: 'start',
    padding: theme.spacing(1.25, 3),
    '&.DPHActive': {
      backgroundColor: theme.palette.background.secondary,
    },
    '&.DPHPickupItem': {
      borderRight: `1px solid ${theme.palette.overlay[1]}`,
    },
  },
  '& .DPHArrowContiner': {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 1,
    backgroundColor: theme.palette.background.tertiary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
    width: theme.spacing(3.5),
    height: theme.spacing(3.5),
    borderRadius: '50%',
  },
  '& .DPHArrowIcon': {
    fontSize: theme.spacing(2.25),
  },
  '& .DPHTitle': {
    marginBottom: theme.spacing(1.25),
    textTransform: 'uppercase',
  },
  '& .DPHClose': {
    width: '100%',
    padding: theme.spacing(2),
  },
  '& .DPHCloseIcon': {
    fontSize: theme.spacing(2),
    marginLeft: 'auto',
    color: theme.palette.common.white,
  },
}));

export { StyledBox };
